export interface TimeOutForm {
  duration: number;
  slots: boolean;
  casino: boolean;
  bets: boolean;
}
export interface TimeOutForbiddenActions {
  type: ForbiddenActions;
  dateEnd: Date;
}

export enum ForbiddenActions {
  casino = "Jugarcasino",
  deposits = "Depositar",
  slots = "Jugarslots",
  bets = "Apostar",
}
